import { useTranslation } from 'react-i18next'
import { useLocation, useSearchParams } from 'react-router'

import { SUBMENU_PARAM_KEY } from '../../constants/route'
import { useSubMenu } from '../../hooks'
import { Breadcrumbs } from '../Breadcrumbs'

import { getBreadcrumbs } from './PageHeader.utils'

import * as styles from './PageHeader.module.css'

function PageHeader({
  breadcrumbs,
  breadcrumbsProps,
  children,
  isLoading,
  itemsCount,
  title,
}) {
  const subMenu = useSubMenu()

  const { t } = useTranslation()

  const location = useLocation()
  const [searchParams] = useSearchParams()

  const sub = searchParams.get(SUBMENU_PARAM_KEY)

  const breadcrumbsList =
    breadcrumbs ||
    getBreadcrumbs({
      headPath: location.pathname,
      sub,
      subMenu,
      t,
      title,
    })

  return (
    <div className={styles.wrapper}>
      <Breadcrumbs
        {...breadcrumbsProps}
        count={itemsCount}
        isLoading={isLoading}
        items={breadcrumbsList}
      />
      {children}
    </div>
  )
}

export default PageHeader
